import React, { useState } from 'react';
import { Icon } from '@fluentui/react';
import EditModal from '../../EditSite/EditModal';
import SiteHistoryModal from '../SiteDetails/SiteHistoryModal';
import { PermissionRole, PowerAppEnvironmentType } from '../../../GlobalConst/globalEnums';
import TempEnvironmentAdminsModal from './TempEnvironmentAdminsModal';
import { useSelector } from "react-redux";

const EnvironmentActionButtonsView = ({ editedItem, callBack }) => {

    const currentUser = useSelector((state) => state.user.currentUser)

    const [showEditModal, setShowEditModal] = useState(false);
    const [showHistoryModal, setShowHistoryModal] = useState(false);
    const [showTempAdminsModal, setShowTempAdminsModal] = useState(false);

    return (
        <div style={iconContainerStyles}>
            <div>
                <Icon style={editIconStyles} onClick={() => setShowEditModal(true)} iconName="edit" />
                <EditModal
                    itemId={editedItem.id}
                    isModalOpened={showEditModal}
                    onCloseModal={() => setShowEditModal(false)}
                    callBack={callBack}
                    isPowerAppEnvironment={true}
                />
            </div>

            <div>
                <Icon style={iconStyles} onClick={() => setShowHistoryModal(true)} iconName="diagnostic" />
                <SiteHistoryModal
                    powerAppEnvironmentId={editedItem.id}
                    title={editedItem.name}
                    isModalOpened={showHistoryModal}
                    onCloseModal={() => setShowHistoryModal(false)}
                />
            </div>
            {
                (currentUser.role === PermissionRole.administrator || editedItem.isOwnedViaSystemAdmins) && !editedItem.isIcofr && editedItem.type !== PowerAppEnvironmentType.developer &&
                <div>
                    <Icon style={iconStyles} onClick={() => setShowTempAdminsModal(true)} iconName="addFriend" />
                    <TempEnvironmentAdminsModal
                        environment={editedItem}
                        isModalOpened={showTempAdminsModal}
                        onCloseModal={() => setShowTempAdminsModal(false)}
                    />
                </div>
            }
        </div>
    );
};

const iconContainerStyles = {
    display: "flex",
};

const editIconStyles = {
    cursor: "pointer",
    margin: "1px 5px",
    fontSize: "14px",
    fontWeight: "600",
};

const iconStyles = {
    cursor: "pointer",
    margin: "0 5px",
    fontSize: "16px",
    fontWeight: "600",
};

export default EnvironmentActionButtonsView;


// WEBPACK FOOTER //
// ./src/components/Administration/PowerPlatform/EnvironmentActionButtonsView.js